import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-days-countdown',
  templateUrl: './days-countdown.component.html',
  styleUrls: ['./days-countdown.component.scss'],
})
export class DaysCountdownComponent {
  @Input() days: any;
}
